import React, { useState, useEffect } from "react";
import Plans from "../../services/plans.service";
import Storage from "../../services/storage.service";
import Translations from "../../services/translation.service";
import User from "../../services/user.service";
import iconClose from "../../assets/img/iconCloseTerms.svg";
import Helpers from "../../helpers/shared.helper";
import FirebaseAnalytics from "../../services/analytics.service";
import CONSTANTS from "../../services/constants.service";
import planFG from "../../services/planFg.service";
import checkModule from "../shared/checkModule";
// import Spinner from "../shared/spinner.component";
const prefix = "content_services_";
const subscriptions = [];
const ContentServiceModal = () => {
    const [translationsKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {});
    const [contentServiceList, setContentServiceList] = useState([]);
    const [showList, setShowList] = useState(false);
    // const [loader, setLoader] = useState(true);
    const [StreamModal, setStreamModal] = useState([]);

    const [duration, setDuration] = useState("");
    const [durationUnit, setDurationUnit] = useState("");

    useEffect(() => {
        // setLoader(true);
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
                // setLoader(false);
            })
        )
        // subscriptions.push(
        //     Storage.get_obsrv("contentServiceList").subscribe(data => {
        //         if (data?.length) {
        //             setContentServiceList(data);
        //             setShowList(true);
        //         }
        //     })
        // );

        Storage.get_obsrv("StreamModal").subscribe(data => {
            setStreamModal(data)
            if (data?.content_list?.length) {
                document.body.classList.add("disable-scroll");
                setContentServiceList(data.content_list);
                getDuration(data?.content_list)
                setShowList(true);
            } else if (!data?.SHOW) {
                setShowList(false);
            }
        })

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }

    }, []);

    const getDuration = (options) => {
        let durationField = "";
        let durationData = options?.[0]?.PromotionDuration || options?.[0]?.Value?.PromotionDuration

        if (durationData === -1) {//If unlimited
            durationField = -1
        } else {
            durationField = Helpers.monthsInDay(durationData) + " ";

            if (durationField === 1) {
                setDurationUnit("stf_offer_duration_label_singular");
            } else {
                setDurationUnit("stf_offer_duration_label_plural");
                if (options?.[0]?.extended_validity) {
                    let extendedValidityInMonths = Helpers.monthsInDay(options?.[0]?.extended_validity);
                    durationField = Helpers.monthsInDay(durationData - options?.[0]?.extended_validity) +
                        ' + ' + extendedValidityInMonths;
                }
            }
        }
        setDuration(durationField)
    }


    const handleClick = () => {
        FirebaseAnalytics.button_clicked(CONSTANTS.PLAN_SELECTION_SCREEN, "ob_choose_this_plan")
        if (StreamModal.Plan_type === "WP_PLAN") {
            doStreamSubmit();
            setShowList(false);
        } else {
            setShowList(false);
            Storage.set("contentServiceSave",
                {
                    'planData': StreamModal?.planData,
                    'Plan_type': StreamModal?.Plan_type,
                });
            Storage.set("contentServiceSave", true);
        }
    };

    const doStreamSubmit = () => {
        if (checkModule.isPlanKsa) {
            doStreamSubmitkSA()
        }
        if (checkModule.isPlanKw) {
            Storage.set("wp_loader", true);
            switch (StreamModal.TYPE) {
                case 'STORAGE_PARAMS_PRD_BUNDLE':
                    Plans.savePredefinedPlan(StreamModal?.planData).then((response) => {
                        Storage.clear("planEdit");
                        Storage.clear("plan_detail_ob");
                        Storage.clear("user_selection");
                        User.fetchFlowStatus();
                    });
                    break;
                default:
            }
        }
    }

    const doStreamSubmitkSA = () => {
        Storage.set("selected_plan_id", StreamModal?.PLAN?.plan_ids, true)
        let data={
            product_code: StreamModal?.PLAN?.product_code,
            plan_ids: StreamModal?.PLAN?.plan_ids
        }
        switch (StreamModal.TYPE) {
            case 'STORAGE_PARAMS_PRD_BUNDLE':
                Plans.saveBundleFromParams(data)
                    .then(response => {
                        User.fetchFlowStatus(4).then(response => {
                            Storage.set("wp_loader", false);
                            Storage.set("StreamModal", {});
                        }).catch(err => {
                            Storage.set("StreamModal", {});
                        })
                    }).catch(error => { });
                break;
            case 'SAVE_PREDEFINED_FG':
                planFG.saveFGplan(data)
                    .then(response => {
                        User.fetchFlowStatus(4).then(response => {
                            Storage.set("StreamModal", {});
                        }).catch(err => {
                            Storage.set("StreamModal", {});
                        })
                    }).catch(error => { Storage.set("StreamModal", {}); });
                break;
            default:
        }
    }

    const getServiceImage = (service_type) => {
        const planImagesData = JSON.parse(
            Storage.get("content_services", true)
        );
        let requiredPlanImage = "";
        if (planImagesData) {
            requiredPlanImage = planImagesData[`services_${service_type.toLowerCase()}_full`]?.url;
        }
        return requiredPlanImage;
    }



    const handleToggleModal = () => {
        Storage.clear("selected_plan_id");

        if (StreamModal.Plan_type === "WP_PLAN") {
            Storage.set("StreamModal",
                {
                    'SHOW': false,
                    'TYPE': "",
                    'Plan_type': "",
                    'PLAN': "",
                    'content_list': '',
                    'planData': '',
                    'wp_close_modal': true

                });
            Storage.clear("user_selection");
            // User.fetchFlowStatus();
        } else {
            Storage.set("StreamModal",
                {
                    'SHOW': false,
                    'TYPE': "",
                    'Plan_type': "",
                    'PLAN': "",
                    'content_list': '',
                    'planData': ''
                });
        }
    }

    const getContenDis = () => {
        let length = contentServiceList?.length;
        return contentServiceList.map((item, index) => {
            const value = typeof item?.Value === "string" ? JSON.parse(item.Value) : (item?.Value || "")

            if (item.Type || item?.Value) {
                return (
                    <>
                        {index === length - 1 && length > 1 ?
                            <>
                                {" "}
                                {Translations.keys["general_or"]}
                                {" "}</>
                            : ""}
                        {Translations.keys[`content_services_${value?.Type || item.Type.toLowerCase()}`]}
                        {length > 2 && index !== length - 1 ? <span>{", "}</span> : ""}

                    </>
                )

            }
            return null;
        })

    }
    return (
        <>
            {showList ?
                <div className="content-service-modal-overlay" onClick={handleToggleModal}>

                    <div className="content-service-modal-wrapper" onClick={(e) => e.stopPropagation()}>
                        {Helpers.isMobile() && <div className="content-service-close-modal">
                            <img
                                className="cross-icon"
                                src={iconClose}
                                alt={"close"}
                                onClick={handleToggleModal}
                            />
                        </div>}
                        {/* {loader ? <SpinnerKw /> : <> */}
                        {/* <div className="content-service-content-container"> */}
                        <div className="header-section">
                            {contentServiceList.map((item, index) => (
                                <div className="image-container"
                                    key={index}
                                >
                                    <img className="backgroudnd-image" src={getServiceImage(item?.Value?.Type || item?.Type)} alt={""} />
                                </div>
                            ))}
                        </div>
                        <div className="text-section">
                            <p className="heading">
                                {translationsKeys["content_service_month_dis"] || "Included one content service"}
                                {" "}
                                {duration && duration !== -1 && checkModule.isPlanKsa ?
                                    <> {translationsKeys["content_service_month_for"] || "for"}
                                        {" "}
                                        {duration + " "}
                                        {translationsKeys[durationUnit] || "month"}</>
                                    : null}
                            </p>


                            <p className="description">
                                {Translations.keys["content_services_type_name"]}
                                {" ("}
                                {getContenDis()}
                                {") "}
                                {Translations.keys["content_services_from_dashbord"]}
                            </p>
                        </div>
                        <button onClick={() => { handleClick() }}>
                            {translationsKeys[prefix + "btn_continue"]}
                        </button>
                    </div>
                </div > : null}

        </>
    );
};

export default ContentServiceModal;
